import { TreeSelectDesignTokens } from '@primeuix/themes/types/treeselect';

import { getColor, getRem } from '@customer-portal/shared/helpers/theme-utils';

export const treeSelectOverride: TreeSelectDesignTokens = {
  root: {
    background: getColor('UiWhite'),
    color: getColor('UiBlack'),
    borderRadius: getRem(10),
    borderColor: getColor('GraphGrey'),
    disabledBackground: getColor('Sandstone95'),
    hoverBorderColor: getColor('Cyan'),
    focusBorderColor: getColor('Cyan'),
    placeholderColor: getColor('PlaceholderGray'),
  },
  tree: {
    padding: getRem(0),
  },
  overlay: {
    borderColor: 'none',
    shadow: `${getRem(0)} ${getRem(3)} ${getRem(6)} ${getRem(0)} ${getColor('DarkBlack')}`,
  },
};
